import React, { useState } from 'react';
import './MindReaderGame.css';

const MindReaderGame: React.FC = () => {
  const [step, setStep] = useState(0);
  const [userNumber, setUserNumber] = useState<number | null>(null);
  const [isRevealed, setIsRevealed] = useState(false);

  const steps = [
    "Think of a number between 1 and 10",
    "Bring the same number from your friend",
    "Take from me 8",
    "Divide by half",
    "Keep one half",
    "Return your friend's number",
    "I predict you have... 4!"
  ];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      setIsRevealed(true);
    }
  };

  const handleRestart = () => {
    setStep(0);
    setUserNumber(null);
    setIsRevealed(false);
  };

  const handleNumberInput = (num: number) => {
    setUserNumber(num);
  };

  return (
    <div className="mind-reader-game">
      <div className="game-header">
        <h2>🔮 Mind Reader</h2>
        <p>Think of a number and I will read your mind!</p>
      </div>

      <div className="game-content">
        {!isRevealed ? (
          <div className="mind-reading-steps">
            <div className="step-indicator">
              <span>Step {step + 1} of {steps.length}</span>
            </div>
            
            <div className="step-content">
              <div className="step-text">
                {steps[step]}
              </div>
              
              {step === 0 && (
                <div className="number-input">
                  <p>What number did you think of?</p>
                  <div className="number-buttons">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                      <button
                        key={num}
                        className="number-btn"
                        onClick={() => handleNumberInput(num)}
                      >
                        {num}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              
              {step < steps.length - 1 && (
                <button className="next-btn" onClick={handleNext}>
                  {step === 0 ? 'I have my number!' : 'Next Step'}
                </button>
              )}
              
              {step === steps.length - 1 && (
                <button className="reveal-btn" onClick={handleNext}>
                  Reveal My Prediction!
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="prediction-result">
            <div className="magic-circle">
              <div className="predicted-number">4</div>
            </div>
            <h3>🎉 I predicted you have 4!</h3>
            <p>Was I right? This is the magic of mathematics!</p>
            
            {userNumber && (
              <div className="calculation-show">
                <h4>Here's the mathematical magic:</h4>
                <div className="calculation-steps">
                  <p>Your number: {userNumber}</p>
                  <p>+ {userNumber} (from friend) = {userNumber + userNumber}</p>
                  <p>+ 8 (from me) = {userNumber + userNumber + 8}</p>
                  <p>÷ 2 = {(userNumber + userNumber + 8) / 2}</p>
                  <p>Keep one half = {(userNumber + userNumber + 8) / 2}</p>
                  <p>- {userNumber} (return to friend) = {((userNumber + userNumber + 8) / 2) - userNumber}</p>
                  <p className="result">= 4 ✨</p>
                </div>
              </div>
            )}
            
            <button className="restart-btn" onClick={handleRestart}>
              Try Again with Another Number
            </button>
          </div>
        )}
      </div>

      <div className="game-footer">
        <p>💡 The secret: No matter what number you choose, the result is always 4!</p>
      </div>
    </div>
  );
};

export default MindReaderGame;
